var _rect, _rect2, _rect3, _rect4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotorRound1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_412_20846)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#FD5358"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_412_20846)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#FD5358"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 1.5,
    width: 36,
    height: 34.5,
    rx: 6,
    fill: "url(#paint0_linear_412_20846)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 34.5,
    width: 36,
    height: 1.5,
    rx: 0.75,
    fill: "url(#paint1_linear_412_20846)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_412_20846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3996 6.55005L20.2496 29.25H15.4996L17.9996 11.35C17.2663 11.8834 16.5329 12.4167 15.7996 12.95C15.0996 13.4834 14.4329 13.9667 13.7996 14.4L12.0996 11.45C12.7663 10.95 13.4496 10.4667 14.1496 10C14.8829 9.50005 15.5496 9.03338 16.1496 8.60005C16.7829 8.16671 17.3663 7.78338 17.8996 7.45005C18.4329 7.08338 18.8496 6.78338 19.1496 6.55005H23.3996Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_412_20846",
    x: 12.0996,
    y: 6.55005,
    width: 11.3008,
    height: 23.6366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.936664
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_412_20846"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_412_20846",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_412_20846",
    x1: 18,
    y1: 1.5,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_412_20846",
    x1: 0,
    y1: 35.25,
    x2: 36,
    y2: 35.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517013,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_412_20846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_412_20846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorRound1);
export default __webpack_public_path__ + "static/media/motor_round_1.0d6f02ae58d9101d68c73260dcf91a93.svg";
export { ForwardRef as ReactComponent };